(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('add-to-cart-button-price')) {
    customElements.define('add-to-cart-button-price', class AddToCartButtonPrice extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || !window.PUB_SUB_EVENTS) return;
        this.variantChangeEnd = (event) => {
          if (event.target.dataset.section !== this.dataset.sectionId) return;
          if (!event.target.currentVariant) this.innerHTML = '';
        };
        window.addEventListener('variantChangeEnd', this.variantChangeEnd);
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          const source = event.data.html.querySelector(`add-to-cart-button-price[data-section-id="${this.dataset.sectionId}"]`);
          this.innerHTML = source ? source.innerHTML : '';
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.variantChangeEnd) window.removeEventListener('variantChangeEnd', this.variantChangeEnd);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wooden-frame-bundle-contents"] && !Shopify.designMode) return;
  try {
    (() => {
    const syncBundleContents = () => {
      const bundle = document.querySelector('[data-wooden-bundle]');
      if (!bundle) return;

      const color = document.querySelector('input[type="radio"][name="Farve"]:checked')?.value || bundle.dataset.defaultColor;
      const packageName = document.querySelector('input[type="radio"][name="Pakke"]:checked')?.value || bundle.dataset.defaultPackage;

      document.querySelectorAll('input[type="radio"][name="Pakke"]').forEach((input) => {
        input.closest('.wt-product__option')?.setAttribute('hidden', '');
      });

      bundle.querySelectorAll('[data-package-card]').forEach((packageCard) => {
        const checked = packageCard.dataset.packageCard === packageName;
        packageCard.querySelector('.mm-starter-package__radio').checked = checked;
        packageCard.querySelector('[data-package-toggle]')?.setAttribute('aria-expanded', String(checked));

        const discounts = Array.from(packageCard.querySelectorAll('[data-bundle-product-price]'))
          .filter((row) => !row.closest('[data-board-card]') || row.closest('[data-board-card]').dataset.boardCard === color)
          .map((row) => Math.round((1 - Number(row.dataset.discountedPrice) / Number(row.dataset.originalPrice)) * 100));
        packageCard.querySelector('[data-package-discount]').textContent = `spar ${Math.min(...discounts)}%`;
      });

      bundle.querySelectorAll('[data-board-card]').forEach((boardCard) => {
        boardCard.hidden = boardCard.dataset.boardCard !== color;
      });
    };

    document.addEventListener('click', (event) => {
      const card = event.target.closest('[data-wooden-bundle] [data-package-card]');
      if (!card) return;

      const input = document.querySelector(`input[type="radio"][name="Pakke"][value="${card.dataset.packageCard}"]`);
      if (!input || input.checked) return;

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.addEventListener('DOMContentLoaded', syncBundleContents);
    document.addEventListener('change', syncBundleContents);
    syncBundleContents();
  })();
  } catch(e) { console.error(e); }
})();

})();
